<div class="category-delete-modal">
  @if (isErrorVariant) {
    <p class="delete-message">
      No se puede eliminar
      <strong>«{{ data.categoryName }}»</strong>
      porque tiene productos asociados:
    </p>

    <ul class="blocking-list">
      @for (product of data.blockingProducts; track product) {
        <li>{{ product }}</li>
      }
    </ul>

    <p class="delete-hint">
      Reasigna o elimina esos productos antes de borrar la categoría.
    </p>

    <div class="delete-actions">
      <button type="button" class="btn btn-primary" (click)="onCancel()">
        Entendido
      </button>
    </div>
  } @else {
    <p class="delete-message">
      ¿Eliminar <strong>«{{ data.categoryName }}»</strong>?
    </p>

    @if (data.hasChildren) {
      <p class="delete-warning">
        Sus subcategorías quedarán sin categoría padre (no se eliminan en cascada).
      </p>
    }

    <div class="delete-actions">
      <button type="button" class="btn btn-outline" (click)="onCancel()">
        Cancelar
      </button>
      <button type="button" class="btn btn-danger" (click)="onConfirm()">
        Confirmar eliminación
      </button>
    </div>
  }
</div>
